import { createContext } from 'react'

/**
 * This context is used to pass additional props to custom-toolbar of {@link BigCalendar}. In react big-calender if we pass additional props by wrapped component method, toolbar component remounts on every render, ultimately child components loose their state. This was causing activity drawer toggle on data load. To avoid this issue we pass additional props via context, and Custom toolbar is passed simply to the 'components' prop of Calender.
 * @constant CalenderContext
 */
export const CalenderContext = createContext()